const VIDEO = process.env.PUBLIC_URL + '/img/acero/WhatsApp Video 2026-05-28 at 12.14.49 PM.mp4';

export default function VideoSection() {
  return (
    <section className="video-section">
      <video
        className="video-section-bg"
        src={VIDEO}
        autoPlay
        muted
        loop
        playsInline
      />
      <div className="video-section-overlay" />
      <div className="video-section-content">
        <p className="section-overline" style={{ justifyContent: 'center' }}>
          Aceros Jalos
        </p>
        <h2 className="video-section-title">
          Calidad en acero,<br />
          <span>directo a tu obra</span>
        </h2>
        <p className="video-section-sub">
          Amplio stock de materiales de acero listos para entrega
          en Jalostotitlán y la región.
        </p>
        <button
          className="btn btn-primary"
          onClick={() => document.getElementById('contacto')?.scrollIntoView({ behavior: 'smooth' })}
        >
          Solicitar cotización
        </button>
      </div>
    </section>
  );
}
